export enum EditState {
  EDIT = 'edit',
  CREATE = 'create',
  DUPLICATE = 'duplicate',
}
